(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('pieometer', pieometer);

    /* @ngInject */
    function pieometer($rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'pieometer.tpl',
            controller: pieometerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                sellerData: '=',
                type: '@',
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            if (!scope.vm.sellerData.hq.goal.value) {
                scope.vm.sellerData.hq.goal.value = 5;
            }
            if (scope.vm.sellerData.photo.value) {
                scope.vm.img = scope.vm.sellerData.photo.value.sizes.thumbnail.url;
            } else {
                scope.vm.img =  scope.vm.type == 'seller' ? $rootScope.globals.default.individualImg : $rootScope.globals.default.teamImg;
            }
            scope.vm.total = scope.vm.sellerData.hq.stats.total;
            scope.vm.price = scope.vm.sellerData.hq.stats.pie_price;
            scope.vm.sold = scope.vm.sellerData.hq.stats.sold;
            scope.vm.progress = Math.round(scope.vm.sold / scope.vm.sellerData.hq.goal.value * 100);
            console.log(scope.vm.total, scope.vm.price, scope.vm.sold, scope.vm.progress);
        }
    }

    /* @ngInject */
    function pieometerController($scope, $rootScope) {
        $scope.vm.baseurl = baseurl;
        // $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';

        // $scope.vm.progress = 0;
        $scope.vm.photo = null;

        $rootScope.uploadMediaValue = '';
        $rootScope.uploadImg = false;
        $scope.vm.openUpload = function(uploadImg, uploadMediaValue) {
            $rootScope.uploadImg = uploadImg;
            $rootScope.uploadMediaValue = uploadMediaValue;
            $rootScope.openModal("upload-media");
            console.log($rootScope.uploadImg, $rootScope.uploadMediaValue);
        };
    }

})();